import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Aguardando from '../common/template/aguardando';

import { 
	setModoTela, initForm, setFiltro, initFormAtualizaPreco, setFormPedido, salvar, excluir, getLista, 
	getListaDistribuidora, getListaPoliticaPreco, getListaUnidade, getListaMotorista, 
	getListaVeiculo, getListaCliente, getListaEndereco, getListaProduto, getListaCustoPrazo,
	getStatusWhatsapp,
	getListaPedidoTipo, getListaPedidoFrete, getListaPedidoCnpj
} from './pedidoActions';
import { getLista as getListaPedidoPrazo } from '../pedidoPrazo/pedidoPrazoActions';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';

class Pedido extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
		this.props.setModoTela('lista');
		this.props.getLista();
		this.props.getListaDistribuidora();
		this.props.getListaPoliticaPreco();
		this.props.getListaCustoPrazo();
		this.props.getListaUnidade();
		this.props.getListaMotorista();
		this.props.getListaVeiculo();
		this.props.getListaCliente();
		this.props.getListaEndereco();
		this.props.getListaProduto();
		this.props.getStatusWhatsapp();
		this.props.getListaPedidoTipo();
		this.props.getListaPedidoFrete();
		this.props.getListaPedidoCnpj();
		this.props.getListaPedidoPrazo();

		let idInterval = setInterval(() => {
			if (this.props.modoTela == 'lista') {
				this.props.getLista();
			}
			this.props.getListaDistribuidora();
			this.props.getListaPoliticaPreco();
			this.props.getListaCustoPrazo();
			this.props.getListaUnidade();
			this.props.getListaMotorista();
			this.props.getListaVeiculo();
			this.props.getListaCliente();
			this.props.getListaEndereco();
			this.props.getListaProduto();
			this.props.getListaPedidoPrazo();
		}, 60000);

		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {	
			clearInterval(this.state.idInterval);
		}
	
    }

    render() {

		const liberarVendaPerdida = true;

		const pedidosBloqueio = this.props.lista
		.filter(item => item.id_status == 1 || item.id_status == 2)
		.filter(item => item.id_usuario_inclusao == (this.props.sessao ? this.props.sessao.id : 0))
		.filter(item => this.validarVendaPerdida(item)).length > 0
		&& !liberarVendaPerdida;

        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'visualizacao' ? (
						<Form onSubmit={this.props.salvar} visualizacao />
					) : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} pedidosBloqueio={pedidosBloqueio} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista(pedidosBloqueio, liberarVendaPerdida) : null}
                </Content>
            </div>
        )
    }

	validarVendaPerdida(registro) {
		return !registro.simulador
			&& DateFormat.formatarDataSqlParaTela(registro.data_pedido) != DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
			&& DateFormat.formatarDataSqlParaTela(registro.data_pedido) != DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(1))
			&& DateFormat.formatarDataSqlParaTela(registro.data_pedido) != DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(2))
			&& DateFormat.formatarDataSqlParaTela(registro.data_pedido) != DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(3))
			&& DateFormat.formatarDataSqlParaTela(registro.data_pedido) != DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(4))
			&& DateFormat.formatarDataSqlParaTela(registro.data_pedido) != DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(5))
			&& DateFormat.formatarDataSqlParaTela(registro.data_pedido) != DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(6))
			&& DateFormat.formatarDataSqlParaTela(registro.data_pedido) != DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(7));
	}

	lista(pedidosBloqueio, liberarVendaPerdida) {

		const lista = this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`${DateFormat.formatarDataSqlParaTela(item.data_pedido)} 
										${this.validarVendaPerdida(item) ? 'Venda Perdida' : (item.simulador ? 'Simulador' : item.nome_status)}
										${item.giro} ${item.nome_motorista} ${item.placa_veiculo} ${item.nome_usuario_inclusao} ${item.clientes || ''}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		}).filter(item => 
			item.id_status == 1 || item.id_status == 2
		)
		.filter(item => {
			if (this.props.usuarioCarregado && [30, 31, 32].includes(this.props.usuarioCarregado.id_perfil)
				&& this.props.usuarioCarregado.ids_gestao_unidade[0]
				&& this.props.usuarioCarregado.ids_gestao_unidade[0] != item.id_unidade) {
				return false
			}
			return true;
		}).filter(item => {
			if ((this.props.filtro.ids_unidades || []).length && !(this.props.filtro.ids_unidades || []).includes(item.id_unidade)) {
				return false;
			}
			if ((this.props.filtro.ids_clientes || []).length && !(item.itens || []).filter(cli => cli && (this.props.filtro.ids_clientes || []).includes(cli.id_cliente)).length) {
				return false;
			}
			if ((this.props.filtro.ids_veiculos || []).length && !(this.props.filtro.ids_veiculos || []).includes(item.id_veiculo)) {
				return false;
			}

			return true;
		});	

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									if (pedidosBloqueio) {
										window.alert('Você tem giros que devem ser tratados como venda perdida. Realize o envio para venda perdida para abrir novos giros.');
									} else {
										this.props.setModoTela('cadastro', {});
										this.props.initForm({ id_tipo: 2 });
									}
								}} />
						</Grid>
						<Grid cols='6 6 4 2'>
							<Button
								text='Simular'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ id_tipo: 2, simulador: true });
								}} />
						</Grid>
						{(this.props.statusWhatsapp && !this.props.statusWhatsapp.conectado) && 
						<Grid cols='6 6 4 4' style={{ maxWidth: 300 }}>
							<button 
								type='button'
								class='btn btn-block btn-danger alerta-piscar'
								style={{ height: 39 }}
								onClick={() => {
									window.open('https://app.z-api.io/', 'blank')
								}}>WhatsApp Desconectado</button>
						</Grid>}
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Row>
						<Select
							options={this.props.listaUnidade}
							label='Unidade'
							cols='12 6 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaUnidade.filter(item => (this.props.filtro.ids_unidades || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_unidades: (values || []).map(item => item.value) });
							}} />
						
						<Select
							options={this.props.listaCliente}
							label='Cliente'
							cols='12 6 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaCliente.filter(item => (this.props.filtro.ids_clientes || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_clientes: (values || []).map(item => item.value) });
							}} />
						
						<Select
							options={this.props.listaVeiculo}
							label='Veículo'
							cols='12 6 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaVeiculo.filter(item => (this.props.filtro.ids_veiculos || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_veiculos: (values || []).map(item => item.value) });
							}} />
					</Row>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th>Data</Th>
								<Th alignCenter>Status</Th>
								<Th alignCenter>Giro</Th>
								<Th alignCenter>Vendedor</Th>
								<Th alignCenter>Clientes</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{DateFormat.formatarDataSqlParaTela(item.data_pedido)}</Td>
									<Td alignCenter 
										bold={item.simulador || this.validarVendaPerdida(item)}
										color={this.validarVendaPerdida(item) ? '#ff0000' : (item.simulador ? '#4f59e3' : null)}>
										{this.validarVendaPerdida(item) ? 'Venda Perdida' : (
											item.simulador ? 'Simulador' : item.nome_status
										)}
									</Td>
									<Td alignCenter>{item.giro}</Td>
									<Td alignCenter>{item.nome_usuario_inclusao}</Td>
									<Td alignCenter>{item.clientes}</Td>
									<Td alignRight minWidth={150}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												
												this.props.setFormPedido('pedido', 'cadastro', item);

												// //Se está digitando atualiza o preço
												// if (item.id_status == 1) {
												// 	this.props.initFormAtualizaPreco({
												// 		...item,
												// 		itens: (item.itens || []).map(pedidoItem => ({
												// 			...pedidoItem,
												// 			quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
												// 			preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
												// 			preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
												// 			preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
												// 			preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
												// 			preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
												// 			valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
												// 			data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
												// 			datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
												// 		}))
												// 	});
												// } else {
												// 	this.props.setModoTela('cadastro', {
												// 		...item,
												// 		itens: (item.itens || []).map(pedidoItem => ({
												// 			...pedidoItem,
												// 			quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
												// 			preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
												// 			preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
												// 			preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
												// 			preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
												// 			preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
												// 			valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
												// 			data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
												// 			datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
												// 		}))
												// 	});
												// 	this.props.initForm({
												// 		...item,
												// 		itens: (item.itens || []).map(pedidoItem => ({
												// 			...pedidoItem,
												// 			quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
												// 			preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
												// 			preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
												// 			preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
												// 			preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
												// 			preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
												// 			valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
												// 			data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
												// 			datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
												// 		}))
												// 	});
												// }
												
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											disabled={!item.simulador && (this.props.sessao && this.props.sessao.id != 1) && !liberarVendaPerdida}
											title={item.simulador ? '' : 'Para giros que não são simulação deve ser usado o recurso de venda perdida'}
											event={() => {
												if (item.simulador || (this.props.sessao && this.props.sessao.id == 1) || liberarVendaPerdida) { 

													this.props.setFormPedido('pedido', 'exclusao', item);

													// this.props.setModoTela('exclusao', {
													// 	...item,
													// 	itens: (item.itens || []).map(pedidoItem => ({
													// 		...pedidoItem,
													// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
													// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
													// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
													// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
													// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
													// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
													// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
													// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
													// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
													// 	}))
													// });
													// this.props.initForm({
													// 	...item,
													// 	itens: (item.itens || []).map(pedidoItem => ({
													// 		...pedidoItem,
													// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
													// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
													// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
													// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
													// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
													// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
													// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
													// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
													// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
													// 	}))
													// });
												}
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.pedido.aguardando,
	modoTela: state.pedido.modoTela,
	filtro: state.pedido.filtro,
	lista: state.pedido.lista,
	listaUnidade: state.pedido.listaUnidade,
	listaCliente: state.pedido.listaCliente,
	listaMotorista: state.pedido.listaMotorista,
	listaVeiculo: state.pedido.listaVeiculo,
	statusWhatsapp: state.pedido.statusWhatsapp
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, setFiltro, initFormAtualizaPreco, setFormPedido, salvar, excluir, getLista, 
	getListaDistribuidora, getListaPoliticaPreco, getListaUnidade, getListaMotorista, 
	getListaVeiculo, getListaCliente, getListaEndereco, getListaProduto, getListaCustoPrazo,
	getStatusWhatsapp,
	getListaPedidoTipo, getListaPedidoFrete, getListaPedidoCnpj, getListaPedidoPrazo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Pedido);
